import styled from 'styled-components';

import { green, black, blue } from 'utils/style/colors';

import Icon from 'components/Icon';

interface IItemPickerHeaderProps {
  showBackButton: boolean;
}

interface IItemPickerListProps {
  loading: boolean;
}

interface IItemPickerBackButtonProps {
  disabled: boolean;
}

interface IItemPickerSaveButtonProps {
  isActive: boolean;
}

export const ItemPickerWrapper = styled('div')`
  height: 100%;
  display: flex;
  user-select: none;
  flex-direction: column;
`;

export const ItemPickerListContainer = styled('div')`
  border: 1px ${black} solid;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
`;

export const ItemPickerHeader = styled('span')<IItemPickerHeaderProps>`
  flex: none;
  height: 3rem;
  padding: ${(props) => (props.showBackButton ? '0 0.9rem' : '0 1.2rem')};
  display: flex;
  background: #f1f1f1;
  align-items: center;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`;

export const ItemPickerFooter = styled('div')`
  flex: none;
  height: 3rem;
  justify-content: space-between;
  padding-inline-start: 1.2rem;
  display: flex;
  background: #f1f1f1;
  align-items: center;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`;

export const ItemPickerHeaderTitle = styled('div')`
  color: ${black};
  overflow: hidden;
  font-weight: 500;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ItemPickerFooterTitle = styled('div')`
  flex: none;
  display: flex;
  align-items: center;
  font-weight: 400;
  margin-inline-end: 1rem;
  & > span {
    margin-left: 1rem;
  }
`;

export const ItemPickerSaveButton = styled('span')<IItemPickerSaveButtonProps>`
  align-items: center;
  background: ${(props) => (props.isActive ? green : '#828282')};
  border-bottom-left-radius: 3px;
  color: var(--exact-white);
  cursor: ${(props) => (props.isActive ? 'pointer' : 'not-allowed')};
  display: inline-flex;
  font-weight: 500;
  justify-content: center;
  border-radius: 2rem;
  opacity: ${(props) => (props.isActive ? 1 : 0.6)};
  padding: 0.3rem 1rem;
  margin-inline-end: 1rem;
  transition: all 0.3s ease;
  :hover {
    opacity: ${(props) => props.isActive && 0.8};
  }
`;

export const ItemPickerList = styled('ul')<IItemPickerListProps>`
  height: 100%;
  margin: 0;
  overflow: auto;
  //overflow: overlay;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  border-top: 1px solid;
  border-bottom: 1px solid;
  ${({ loading }) =>
    loading &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const ItemPickerBackButton = styled(Icon)<IItemPickerBackButtonProps>`
  cursor: pointer;
  padding: 0.2rem;
  font-size: 1.4rem !important;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  margin-inline-end: 0.7rem;
  border-radius: 25px;
  :hover {
    color: var(--exact-white) !important;
    background-color: ${green};
  }
  ${({ disabled }) =>
    disabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const RelatedItemChip = styled('span')`
  display: inline-flex;
  align-items: center;
  line-height: 2rem;
  padding: 0 0.5rem;
  border-radius: 10px;
  color: var(--exact-white);
  background-color: ${blue};
  margin: 3px;
  //width: -webkit-fill-available;
`;

// TODO: fix width style
export const RelatedItemTitle = styled('span')`
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 32rem;
`;

export const RemoveIcon = styled(Icon)`
  cursor: pointer;
  float: right;
  font-size: 1rem !important;
  line-height: 2rem;
  padding-inline-start: 0.5rem;
`;

export const LoadingWrapper = styled('span')`
  top: 50%;
  left: 50%;
  z-index: 1;
  position: absolute;
  opacity: 1 !important;
`;
